/* ==========================================================================
   CL · Dock Mobile — comportamiento
   - Carrito: abre el cart-drawer del tema si existe (si no, va a /cart)
     y mantiene el contador sincronizado observando #cart-icon-bubble
     (el tema reescribe ese nodo en cada cambio del carrito).
   - Menú/Categorías: abre el drawer del navbar glass ([data-cl-drawer-open]);
     si el navbar no está, navega al enlace de respaldo del bloque.
   - Buscador: abre el modal de búsqueda del navbar y enfoca su input
     dentro del tap (Searchanise, enganchado vía search-open-btn, abre su
     panel al detectar el foco); si la app no está presente, navega a /search.
   - Reserva espacio abajo del <body> para que el dock no tape el footer.
   ========================================================================== */

(function () {
	'use strict';

	function initDock(dock) {
		if (!dock || dock.dataset.clInit === 'true') return;
		dock.dataset.clInit = 'true';

		/* PDP: el dock vive oculto y solo se asoma mientras el sheet está
		   abierto (la hamburguesa lo abre); al cerrarlo vuelve a esconderse */
		var pdpMode = dock.dataset.pdpHide === 'true';
		if (pdpMode) dock.classList.add('cl-dock--pdp');

		/* ---------- Carrito ---------- */
		var cartBtns = dock.querySelectorAll('[data-cl-dock-cart]');

		function setCount(n) {
			dock.querySelectorAll('.cl-dock__badge').forEach(function (b) {
				b.textContent = n;
				b.setAttribute('data-count', String(n));
			});
		}

		cartBtns.forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				var drawer = document.querySelector('cart-drawer');
				if (drawer && typeof drawer.open === 'function') {
					event.preventDefault();
					drawer.open(btn);
				}
				/* sin drawer: sigue el href a la página del carrito */
			});
		});

		/* Contador en vivo: el tema reemplaza el contenido de
		   #cart-icon-bubble al actualizar el carrito */
		var bubble = document.getElementById('cart-icon-bubble');
		if (bubble && 'MutationObserver' in window) {
			var sync = function () {
				var c = bubble.querySelector('.cart-count-bubble');
				var n = 0;
				if (c) {
					/* OJO: el bubble trae el número DOS veces (el visible y el
					   texto para lectores de pantalla "1 artículo") — leer todo
					   el textContent pegaba ambos dígitos y marcaba "11".
					   Se lee SOLO el span visible y el primer número. */
					var visible = c.querySelector('[aria-hidden="true"]') || c;
					var m = visible.textContent.match(/\d+/);
					n = m ? parseInt(m[0], 10) : 0;
				}
				setCount(n);
			};
			new MutationObserver(sync).observe(bubble, { childList: true, subtree: true, characterData: true });
		}

		/* ---------- Menú (drawer del navbar) ---------- */
		dock.querySelectorAll('[data-cl-dock-menu]').forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				var opener = document.querySelector('[data-cl-drawer-open]');
				if (opener) {
					event.preventDefault();
					opener.click();
				}
				/* sin navbar: sigue el href de respaldo */
			});
		});

		/* ---------- Buscador ----------
		   Réplica del mecanismo COMPLETO de la lupa del navbar. La lupa
		   funciona por DOS handlers que cooperan: el del navbar abre su
		   modal (clase header__search-inner--open → display:block) y
		   enfoca el input; el de Searchanise (clase search-open-btn)
		   re-enfoca a los 250ms y su widget abre el panel al detectar el
		   foco. El dock solo tenía la mitad (Searchanise): nadie abría el
		   modal, el input seguía dentro de un display:none y focus() ahí
		   ES UN NO-OP — por eso en iPhone no abría o pedía varios taps.
		   Aquí se abre el modal y se enfoca SÍNCRONO, dentro del tap real
		   (iOS solo muestra teclado con foco ligado a un gesto real). */
		dock.querySelectorAll('[data-cl-dock-search]').forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				event.preventDefault();
				closeSheet();
				var modal = document.querySelector('[data-cl-search-modal]');
				var appPresent = document.querySelector('[class*="snize"]') || window.Searchanise;
				if (modal && appPresent) {
					modal.classList.add('header__search-inner--open');
					var input = modal.querySelector('input[name="q"]');
					if (input) {
						try {
							input.focus({ preventScroll: true });
						} catch (e) {
							input.focus();
						}
					}
					return; /* Searchanise refuerza a los 250ms vía search-open-btn */
				}
				/* sin app (o sin modal del navbar): mismo destino que la lupa */
				var navBtn =
					document.querySelector('.cl-navglass__bar--mobile [data-cl-search]') ||
					document.querySelector('.cl-navglass [data-cl-search]');
				if (navBtn) {
					navBtn.click();
					return;
				}
				window.location.href = btn.dataset.searchUrl || '/search';
			});
		});

		/* ---------- Sheet de categorías (sube desde abajo) ---------- */
		var sheet = document.querySelector('[data-cl-dock-sheet-panel]');
		var dim = document.querySelector('[data-cl-dock-dim]');

		function closeSheet() {
			if (sheet) {
				sheet.classList.remove('is-open');
				/* al cerrar vuelve a la vista de categorías */
				sheet.classList.remove('is-sub');
			}
			if (dim) dim.classList.remove('is-open');
			/* se desbloquea el scroll del fondo */
			document.body.classList.remove('cl-dock-lock');
			if (pdpMode) dock.classList.remove('cl-dock--pdp-open');
		}

		function openSheet() {
			if (!sheet) return;
			sheet.classList.add('is-open');
			if (dim) dim.classList.add('is-open');
			/* scroll del fondo bloqueado mientras el menú está abierto */
			document.body.classList.add('cl-dock-lock');
			if (pdpMode) dock.classList.add('cl-dock--pdp-open');
		}

		function toggleSheet() {
			if (!sheet) return;
			if (sheet.classList.contains('is-open')) {
				closeSheet();
			} else {
				openSheet();
			}
		}

		dock.querySelectorAll('[data-cl-dock-sheet]').forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				if (sheet) {
					event.preventDefault();
					toggleSheet();
				}
				/* sin bloques de categoría: sigue el href de respaldo */
			});
		});

		if (dim) dim.addEventListener('click', closeSheet);
		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') closeSheet();
		});

		/* ---------- Agarradera: tap cierra; arrastre hacia abajo
		   el panel sigue al dedo y suelta para cerrar ---------- */
		var grab = sheet ? sheet.querySelector('[data-cl-dock-grab]') : null;
		if (grab && sheet) {
			var dragging = false;
			var dragStartY = 0;
			var dragDelta = 0;

			grab.addEventListener('pointerdown', function (event) {
				dragging = true;
				dragStartY = event.clientY;
				dragDelta = 0;
				sheet.classList.add('is-dragging');
				if (grab.setPointerCapture) grab.setPointerCapture(event.pointerId);
			});

			grab.addEventListener('pointermove', function (event) {
				if (!dragging) return;
				dragDelta = Math.max(0, event.clientY - dragStartY);
				sheet.style.transform = 'translateY(' + dragDelta + 'px)';
			});

			var endDrag = function () {
				if (!dragging) return;
				dragging = false;
				sheet.classList.remove('is-dragging');
				sheet.style.transform = '';
				/* arrastre suficiente → se cierra; poco → regresa suave */
				if (dragDelta > 70) closeSheet();
			};
			grab.addEventListener('pointerup', endDrag);
			grab.addEventListener('pointercancel', endDrag);

			/* tap simple en la línea también cierra */
			grab.addEventListener('click', function () {
				if (dragDelta <= 6) closeSheet();
			});
		}

		/* ---------- Ocultar el dock cuando el navbar está en pantalla ----------
		   Observa la barra mobile del navbar glass: mientras cualquier
		   pixel de ella sea visible, el dock se esconde (y si el sheet
		   estaba abierto, se cierra). OJO: si el sticky del navbar está
		   ACTIVADO, la barra queda fija siempre visible y el dock no
		   aparecería nunca — esta regla está pensada para usarse con el
		   sticky del navbar apagado (arriba navbar, abajo dock). */
		var ioActivo = false;
		if (!pdpMode && dock.dataset.hideWithNavbar === 'true' && 'IntersectionObserver' in window) {
			var navBar = document.querySelector('.cl-navglass__bar--mobile') || document.querySelector('.cl-navglass');
			if (navBar) {
				ioActivo = true;
				var primeraVez = true;
				var io = new IntersectionObserver(function (entries) {
					var navVisible = entries[0].isIntersecting;
					dock.classList.toggle('cl-dock--hidden', navVisible);
					if (navVisible && !primeraVez) closeSheet();
					if (primeraVez) {
						primeraVez = false;
						/* ya con el estado correcto aplicado, se revela el
						   dock (anti-parpadeo del CSS) */
						window.setTimeout(function () {
							dock.classList.add('cl-dock--ready');
						}, 0);
					}
				}, { threshold: 0 });
				io.observe(navBar);
			}
		}
		if (!ioActivo) dock.classList.add('cl-dock--ready');

		/* ---------- Subcategorías dentro del sheet ----------
		   Las categorías con menú asignado abren una segunda vista:
		   el contenido sale del <template> que imprime el Liquid. */
		if (sheet) {
			var subTitle = sheet.querySelector('[data-cl-dock-subtitle]');
			var subContent = sheet.querySelector('[data-cl-dock-subcontent]');

			sheet.querySelectorAll('[data-cl-dock-sub]').forEach(function (btn) {
				btn.addEventListener('click', function () {
					var tpl = sheet.querySelector('template[data-sub-src="' + btn.getAttribute('data-cl-dock-sub') + '"]');
					if (!tpl || !subContent) return;
					/* píldoras + la mini vitrina propia de esa categoría */
					subContent.innerHTML = tpl.innerHTML;
					if (subTitle) subTitle.textContent = btn.getAttribute('data-sub-title') || '';
					sheet.classList.add('is-sub');
				});
			});

			var backBtn = sheet.querySelector('[data-cl-dock-back]');
			if (backBtn) {
				backBtn.addEventListener('click', function () {
					sheet.classList.remove('is-sub');
				});
			}

			/* ---------- La hamburguesa del navbar abre ESTE menú ----------
			   Se intercepta el clic en fase de captura (corre antes que el
			   handler del navbar) y se detiene ahí: el drawer clásico ya no
			   se abre y en su lugar sube el sheet. No se tocan los archivos
			   del navbar, así que funciona con cualquier versión. */
			if (dock.dataset.burgerOpensSheet === 'true') {
				document.addEventListener(
					'click',
					function (event) {
						var opener = event.target.closest('[data-cl-drawer-open]');
						if (!opener) return;
						event.preventDefault();
						event.stopPropagation();
						toggleSheet();
					},
					true
				);
			}
		}

		/* ---------- Espacio inferior ----------
		   Reserva padding en el body para no tapar el footer y publica
		   --cl-dock-clear (alto del dock + separación): la usan el sheet
		   para no quedar debajo y la regla que sube el botón de WhatsApp. */
		function reserve() {
			if (getComputedStyle(dock).display === 'none') {
				document.body.style.paddingBottom = '';
				document.documentElement.style.removeProperty('--cl-dock-clear');
				return;
			}
			var h = dock.offsetHeight + parseFloat(getComputedStyle(dock).bottom || '0');
			document.documentElement.style.setProperty('--cl-dock-clear', h + 'px');
			/* en la PDP el dock no ocupa lugar: sin padding en el body */
			if (!pdpMode) document.body.style.paddingBottom = (h + 10) + 'px';
		}
		var t;
		window.addEventListener('resize', function () {
			window.clearTimeout(t);
			t = window.setTimeout(reserve, 150);
		}, { passive: true });
		reserve();

		/* ---------- Precalienta las imágenes de los <template> ----------
		   Las vitrinas por categoría viven en templates (inertes): sus
		   imágenes no se descargan hasta el tap y la vista salía vacía
		   o lenta. En tiempo muerto se piden para dejarlas en caché. */
		if (sheet) {
			var prewarm = function () {
				sheet.querySelectorAll('template').forEach(function (tpl) {
					if (!tpl.content) return;
					tpl.content.querySelectorAll('img').forEach(function (im) {
						var src = im.getAttribute('src');
						if (!src) return;
						var pre = new Image();
						if (im.getAttribute('srcset')) pre.srcset = im.getAttribute('srcset');
						pre.src = src;
					});
				});
			};
			if ('requestIdleCallback' in window) {
				window.requestIdleCallback(prewarm, { timeout: 4000 });
			} else {
				window.setTimeout(prewarm, 2500);
			}
		}

		/* ---------- Listo: re-dispara el tap que llegó antes de cargar ----------
		   El script inline de la sección atrapa los clics tempranos
		   (evitando que naveguen) y deja el botón en __clDockPending. */
		window.__clDockReady = true;
		if (window.__clDockPending) {
			var pendiente = window.__clDockPending;
			window.__clDockPending = null;
			if (pendiente && pendiente.click) pendiente.click();
		}
	}

	function initAll() {
		document.querySelectorAll('[data-cl-dock]').forEach(initDock);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
